// src/pages/ChatWithAI/components/AttachmentBox.js
import React, { useState } from 'react';
import AnexarUnificadoDialog from '../../../components/dialogs/AnexarUnificadoDialog';
import AnexarDocumentoDialog from './dialogs/AnexarDocumentoDialog';
import AnexarCasoDialog from './dialogs/AnexarCasoDialog';
import AnexarClienteDialog from './dialogs/AnexarClienteDialog';
import AnexarOneDriveDialog from './dialogs/AnexarOneDriveDialog';
import './AttachmentBox.css';

const AttachmentBox = ({
  isOpen,
  onClose,
  anexos,
  loading,
  onAnexarTextoTranscrito,
  onAnexarDocumento,
  onAnexarCaso,
  onAnexarCliente,
  onRemoverAnexo
}) => {
  const [dialogAberto, setDialogAberto] = useState(null);

  // 🔥 VALIDAÇÃO REMOVIDA - Agora permite abrir diálogos sem thread
  const handleOpenDialog = (tipo) => {
    setDialogAberto(tipo);
  };

  const getIconeAnexo = (tipo) => {
    const icones = {
      file: '📄',
      document: '📝',
      case: '📁',
      client: '👤'
    };
    return icones[tipo] || '📎';
  };

  const getTituloAnexo = (anexo) => {
    if (anexo.filename) return anexo.filename;
    if (anexo.casoName) return anexo.casoName;
    if (anexo.clientCode) return `Cliente ${anexo.clientCode}`;
    return anexo.preview?.substring(0, 30) || 'Anexo';
  };

  const handleRemover = async (anexoId) => {
    if (window.confirm('Remover este anexo do contexto?')) {
      try {
        await onRemoverAnexo(anexoId);
      } catch (error) {
        alert(error.message);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="attachment-box-overlay" onClick={onClose} />
      
      <div className="attachment-box">
        <div className="attachment-box-header">
          <h3>Anexos</h3>
          <button className="attachment-box-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="attachment-box-content">
          {loading && (
            <div className="attachment-loading">
              Carregando...
            </div>
          )}

          {!loading && anexos.length === 0 && (
            <div className="attachment-empty">
              <p>Nenhum anexo nesta conversa</p>
              <p className="attachment-hint">💡 Anexe documentos, casos ou clientes para enriquecer o contexto</p>
            </div>
          )}

          {!loading && anexos.length > 0 && (
            <ul className="attachment-list">
              {anexos.map(anexo => (
                <li key={anexo.id} className="attachment-item">
                  <span className="attachment-icon">{getIconeAnexo(anexo.tipo)}</span>
                  <span className="attachment-title" title={anexo.preview}>
                    {getTituloAnexo(anexo)}
                  </span>
                  <span className="attachment-words">{anexo.word_count} palavras</span>
                  <button
                    className="attachment-remove-btn"
                    onClick={() => handleRemover(anexo.id)}
                    title="Remover do contexto"
                  >
                    ✕
                  </button>
                </li>
              ))}
            </ul>
          )}

          <div className="attachment-actions">
            <button
              className="attachment-action-btn"
              onClick={() => handleOpenDialog('ficheiro')}
            >
              <span className="btn-icon">📎</span>
              Anexar Ficheiro / Áudio
            </button>

            <button 
              className="attachment-action-btn"
              onClick={() => handleOpenDialog('documento')}
            >
              <span className="btn-icon">📝</span>
              Anexar Documento Gerado
            </button>

            <button 
              className="attachment-action-btn"
              onClick={() => handleOpenDialog('caso')}
            >
              <span className="btn-icon">📁</span>
              Anexar Caso
            </button>

            <button
              className="attachment-action-btn"
              onClick={() => handleOpenDialog('cliente')}
            >
              <span className="btn-icon">👤</span>
              Anexar Cliente
            </button>

            {onAnexarTextoTranscrito && (
              <button
                className="attachment-action-btn"
                onClick={() => handleOpenDialog('onedrive')}
              >
                <span className="btn-icon">☁️</span>
                Anexar Ficheiros OneDrive
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Diálogos */}
      {dialogAberto === 'ficheiro' && (
        <AnexarUnificadoDialog
          onClose={() => setDialogAberto(null)}
          onAnexar={onAnexarTextoTranscrito}
          titulo="Anexar Ficheiro ou Documento"
        />
      )}

      {dialogAberto === 'documento' && (
        <AnexarDocumentoDialog
          onClose={() => setDialogAberto(null)}
          onAnexar={onAnexarDocumento}
        />
      )}

      {dialogAberto === 'caso' && (
        <AnexarCasoDialog
          onClose={() => setDialogAberto(null)}
          onAnexar={onAnexarCaso}
        />
      )}

      {dialogAberto === 'cliente' && (
        <AnexarClienteDialog
          onClose={() => setDialogAberto(null)}
          onAnexar={onAnexarCliente}
        />
      )}

      {dialogAberto === 'onedrive' && (
        <AnexarOneDriveDialog
          onClose={() => setDialogAberto(null)}
          onAnexar={onAnexarTextoTranscrito}
        />
      )}
    </>
  );
};

export default AttachmentBox;